<template>
	<div>
    <h1>1. INSTALLATION</h1>
    <p>
    Patch your Pokèmon Emerald English ROM (sha1: f3ae088181bf583e55daf962a92bb46f4f1d07b7)
    with Lunar IPS using the provided patch file.
    </p>
    <h1>2. DETAILS</h1>
    <p>
    Translation sequence:
    English -> Russian -> Spanish -> Japanese -> Finnish -> Arabic -> Corsican -> Chinese (Simplified) -> English
    </p>
    <b style="text-align: left">Text translated:</b>
    <ul style="text-align: left">
      <li>Ability names</li>
      <li>Ability descriptions</li>
      <li>Natures</li>
      <li>Type names</li>
      <li>Move names</li>
      <li>Move descriptions</li>
      <li>Pokémon names</li>
      <li>Pokémon Pokédex descriptions</li>
      <li>Battle text</li>
      <li>Options menu</li>
      <li>Choice menus</li>
      <li>Start menu</li>
      <li>Dialog text</li>
      <li>Match call messages</li>
      <li>Trainer classes</li>
      <li>Trainer names</li>
      <li>Item names</li>
      <li>Item descriptions</li>
      <li>Credits</li>
      <li>Miscellaneous text</li>
    </ul>
    <h1>3. Download</h1>
    <a href="/Google translated Pokemon Emerald.zip">Click here</a>
	</div>
</template>

<script>

export default {
	data: () => ({
		
	}),
	methods: {
		
	}
}

</script>

<style scoped>

</style>
